<template>
	<div class="layout-grid bt1 bl1">
		<template v-for="(r, rIndex) in row">
			<ARow :key="`row-${rIndex}}`" class="layout-grid-row">
				<template v-for="(c, cIndex) in col">
					<ACol :key="`col-${rIndex}-${cIndex}}`" class="layout-grid-col br1 bb1">
						<div class="layout-grid-col-label">{{ getAttrLabel((rIndex * col) + cIndex)}}</div>
						<div class="layout-grid-col-value" :style="activation(getAttrValue((rIndex * col) + cIndex))">
							{{ getAttrValue((rIndex * col) + cIndex)}}</div>
					</ACol>
				</template>
			</ARow>
		</template>
		<slot></slot>
	</div>
</template>
<script>
	export default {
		props: {
			/** 行数 */
			row: {
				type: Number,
				default: 3
			},
			/** 列数 */
			col: {
				type: Number,
				default: 3
			},
			attrList: {
				type: [Array, Object],
				default: () => []
			}
		},
		data() {
			return {

			};
		},
		computed: {
			activation() {
				return (icontent) => { // 使用JavaScript闭包，进行传值操作
					if (icontent === "待记录") {
						return {
							'background': 'yellow'
						}
					} else if (icontent === "已完成") {
						return {
							'background': 'rgb(43, 255, 78)'
						}
					} else if (icontent === "wining") {
						return {
							'color': 'yellow'
						}
					}

				}
			}
		},
		mounted() {
		},
		methods: {
			getAttr(index) {
				return this.attrList[index] || {}
			},
			getAttrLabel(index) {
				let attr = this.getAttr(index)
				return attr.key || attr.name
			},
			getAttrValue(index) {
				return this.getAttr(index).value
			},
		}
	};
</script>
<style lang="less" scoped>
	.red {
		color: black;

	}

	.green {
		color: black;
		background: yellow;

	}

	.layout-grid {
		font-size: 22px;

		.layout-grid-row {
			display: flex;
			min-height: 45px;

			.layout-grid-col {
				flex: 1;
				display: flex;

				>div {
					display: flex;
					align-items: center;
					justify-content: center;
					padding: 5px 8px;
				}

				.layout-grid-col-label {
					color: @white;
					flex: 0.45;
					background: @theme-color;
				}

				.layout-grid-col-value {
					flex: 0.55;
				}
			}
		}
	}
</style>